import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mt-6 mb-13"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }